import { useQuery } from "@tanstack/react-query";
import { fetchIpList, fetchIpStats, fetchIpDetails } from "./ipLookupAPI";

export function useIpList(options = {}) {
    const { page, limit, search, country, flaggedOnly, fromDate, toDate } = options;
    return useQuery({
        queryKey: ["ipList", page, limit, search, country, flaggedOnly, fromDate, toDate],
        queryFn: () => fetchIpList(options),
        keepPreviousData: true,
    });
}

export function useIpStats() {
    return useQuery({
        queryKey: ["ipStats"],
        queryFn: fetchIpStats,
    });
}

export function useIpDetails(ip, enabled = true) {
    return useQuery({
        queryKey: ["ipDetails", ip],
        queryFn: () => fetchIpDetails(ip),
        enabled: !!ip && enabled,
    });
}
